import React, { useEffect, useState } from "react";
import {
  UserGroupIcon,
  BuildingOfficeIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
 import {    Card, CardContent, Typography } from "@mui/material";
 import {
 
 
 
 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

import {
  getAllCandidates,
  getCandidatesByBranch,
  getProgramWiseCount,
  getProjectWiseCount,
  approveCandidate,
} from "../Api/candidateApi";

import {
  getProjectStats,
  getAllProjects,
  getProgramsByProject,
  getAllProgramsByProject,
} from "../Api/projectApi";
import { getAllBranches } from "../Api/branches";
import { useNavigate } from "react-router-dom";
import { Grid,   } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { BiShow } from "react-icons/bi";


/* ================= COLORS ================= */
const PROJECT_COLORS = {
  "Shriram Finance": "#FFCB09",
  Mahindra: "#E31836",
  Linde: "#002D54",
};

const DEFAULT_PROJECT_COLOR = "#1E293B";
const PROJECT_NORMALIZE_MAP = {
  "Linde Hazmat": "Linde",
  "Linde Upskilling": "Linde",
  "SSSF Upskilling": "Shriram Finance",
};

const Dashboard = () => {
  /* ================= STATE ================= */
  const [view, setView] = useState("dashboard"); // dashboard | projects | programs | locations | allPrograms
  const [previousView, setPreviousView] = useState(null);
const navigate = useNavigate();
const role = localStorage.getItem("role"); // "admin" | "branchUser"

  const [enrollCount, setEnrollCount] = useState(0);
  const [projectCount, setProjectCount] = useState(0);
  const [programCount, setProgramCount] = useState(0);
const [loading, setLoading] = useState(true);
const [locationFilter, setLocationFilter] = useState("");

  const [projects, setProjects] = useState([]);
  const [programs, setPrograms] = useState([]);

  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProgram, setSelectedProgram] = useState(null);
 
const [selectedBranch, setSelectedBranch] = useState(null);
const [centerCandidates, setCenterCandidates] = useState([]);
const [branchCounts, setBranchCounts] = useState({});
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
 const [projectCounts, setProjectCounts] = useState({});
const [programCounts, setProgramCounts] = useState({});

const [selectedDate, setSelectedDate] = useState("");
const [todayCount, setTodayCount] = useState(0);
const [allCenterCandidates, setAllCenterCandidates] = useState([]);
const [locationChart, setLocationChart] = useState([]);
const [projectChart, setProjectChart] = useState([]);
const [loadingProjects, setLoadingProjects] = useState(false);
const [loadingCharts, setLoadingCharts] = useState(false);
const [approvalDialog, setApprovalDialog] = useState(false);
const [approvalStatus, setApprovalStatus] = useState("");
const [approvalReason, setApprovalReason] = useState("");
const [approvalCandidate, setApprovalCandidate] = useState(null);

const [viewDialogOpen, setViewDialogOpen] = useState(false);
const [selectedCandidate, setSelectedCandidate] = useState(null);

  const [allProgramsByProject, setAllProgramsByProject] = useState({});
const [loadingLocations, setLoadingLocations] = useState(false);

  /* ================= VIEW HANDLER ================= */
  const changeView = (nextView) => {
    setPreviousView(view);
    setView(nextView);
  };

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    fetchCounts();
  }, []);

const fetchCounts = async () => {
  setLoading(true);
  try {
    const resCandidates = await getAllCandidates(1, 1);
    setEnrollCount(resCandidates?.data?.total || 0);

    const stats = await getProjectStats();
    setProjectCount(stats?.data?.totalProjects || 0);
    setProgramCount(stats?.data?.totalPrograms || 0);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
const fetchChartData = async () => {
  try {
    setLoadingCharts(true);

    const branchesRes = await getAllBranches();
    const branches = branchesRes.data.data || [];

    const locationData = await Promise.all(
      branches.map(async (branch) => {
        const r = await getCandidatesByBranch(branch._id, 1, 1);
        return {
          label: branch.name,
          value: r.data.total || 0,
        };
      })
    );

    setLocationChart(locationData);

    const projectRes = await getProjectWiseCount();
    const projectData = Object.keys(projectRes.data.data || {}).map(
      (key) => ({
        label: key,
        value: projectRes.data.data[key],
      })
    );

    setProjectChart(projectData);
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingCharts(false);
  }
};

 useEffect(() => {
  fetchCounts();
  fetchChartData();
}, []);

  /* ================= HANDLERS ================= */

  // Dashboard → Projects
const handleProjectClick = async () => {
  try {
    setLoadingProjects(true);

    const res = await getAllProjects();
    setProjects([...new Set(res.data.map((p) => p.projectName))]);

    const countRes = await getProjectWiseCount();
    setProjectCounts(countRes.data.data || {});

    changeView("projects");
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingProjects(false);
  }
};


  const handleOpenProject = async (project) => {
  setSelectedProject(project);
  setSelectedProgram(null);

  const res = await getProgramsByProject(project);
  setPrograms(res.data);

  const countRes = await getProgramWiseCount(project);
  setProgramCounts(countRes?.data?.data || {});

  changeView("programs");
};
const handleProgramClick = async (program) => {
  try {
    setLoadingLocations(true); // 🔥 START LOADER

    const res = await getAllBranches();

    const filtered = res.data.data.filter(
      (b) => b.project === selectedProject && b.program === program
    );

    // ⚡ FAST: parallel API calls
    const results = await Promise.all(
      filtered.map(async (branch) => {
        const r = await getCandidatesByBranch(branch._id, 1, 1000);
        const list = r.data.data || [];

        return {
          branchId: branch._id,
          total: list.length,
          approved: list.filter(
            (c) => c.approvalstatus === "Approved"
          ).length,
        };
      })
    );

    const counts = {};
    results.forEach((r) => {
      counts[r.branchId] = {
        total: r.total,
        approved: r.approved,
      };
    });

    setBranchCounts(counts);
    setSelectedProgram({
      name: program,
      branches: filtered,
    });

    changeView("locations");
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingLocations(false); // 🔥 STOP LOADER
  }
};

const locationOptions =
  selectedProgram?.branches
    ? [...new Set(selectedProgram.branches.map(b => b.location))]
    : [];




  // Dashboard → All Programs
  const handleAllProgramsClick = async () => {
    const res = await getAllProgramsByProject();
    setAllProgramsByProject(res.data || {});
    changeView("allPrograms");
  };
const SkeletonCard = () => (
  <div className="p-6 rounded-xl bg-gray-200 animate-pulse h-28" />
);

const handleCenterClick = async (branch) => {
  try {
    setSelectedBranch(branch);

    const res = await getCandidatesByBranch(branch._id);
    const list = res.data.data || [];

    setAllCenterCandidates(list);
    setCenterCandidates(list);

    // ✅ today count (initial)
    const today = new Date().toDateString();
    setTodayCount(
      list.filter(
        (c) => new Date(c.createdAt).toDateString() === today
      ).length
    );

    changeView("centerCandidates");
  } catch (error) {
    console.error("Failed to load center candidates", error);
  }
};


const applyDateFilter = async () => {
  const res = await getCandidatesByBranch(
    selectedBranch._id,
    1,
    1000
  );

  const list = res.data.data || [];

  const filtered = list.filter((c) => {
    const created = new Date(c.createdAt);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    if (from && created < from) return false;
    if (to && created > to) return false;
    return true;
  });

  setCenterCandidates(filtered);

  // 📅 Today count
  const today = new Date().toDateString();
  setTodayCount(
    filtered.filter(
      (c) => new Date(c.createdAt).toDateString() === today
    ).length
  );
};
useEffect(() => {
  if (!selectedDate) {
    setCenterCandidates(allCenterCandidates);
    return;
  }

  const picked = new Date(selectedDate).toDateString();

  const filtered = allCenterCandidates.filter(
    (c) => new Date(c.createdAt).toDateString() === picked
  );

  setCenterCandidates(filtered);
}, [selectedDate, allCenterCandidates]);
 const LocationSkeleton = () => (
  <div className="space-y-3">
    {[1, 2, 3, 4, 5].map((i) => (
      <div
        key={i}
        className="h-12 bg-gray-200 rounded animate-pulse"
      />
    ))}
  </div>
);
const ProjectSkeleton = () => (
  <div className="p-6 rounded-xl bg-gray-200 animate-pulse h-24 flex justify-between items-center">
    <div className="h-4 w-32 bg-gray-300 rounded"></div>
    <div className="h-6 w-10 bg-gray-300 rounded-full"></div>
  </div>
);
const ProgramSkeleton = () => (
  <div className="p-5 bg-gray-200 rounded-lg animate-pulse flex justify-between items-center">
    <div className="h-4 w-28 bg-gray-300 rounded"></div>
    <div className="h-6 w-10 bg-gray-300 rounded-full"></div>
  </div>
);
const ChartSkeleton = ({ height = 300 }) => (
  <div
    className="w-full bg-gray-200 animate-pulse rounded-lg"
    style={{ height }}
  />
);

  /* ================= RENDER ================= */
  return (
    <div className="p-8">

      {/* ===== BACK BUTTON ===== */}
      {view !== "dashboard" && (
        <button
          onClick={() => {
            setView(previousView || "dashboard");
            setPreviousView(null);
          }}
          className="mb-6 px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800"
        >
          ← Back
        </button>
      )}

      {/* ================= DASHBOARD ================= */}
{view === "dashboard" && (
  <>
    {loading ? (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          onClick={() => navigate("/candidates")}
          className="p-6 bg-[#2BB5CE] text-white rounded-xl shadow-lg 
                     flex gap-4 items-center cursor-pointer hover:scale-[1.03]"
        >
          <UserGroupIcon className="w-12 h-12" />
          <div>
            <p>Total Enrollments</p>
            <p className="text-4xl font-bold">{enrollCount}</p>
          </div>
        </div>

{role !== "branchUser" && (
  <div
    onClick={handleProjectClick}
    className="p-6 bg-[#1E293B] text-white rounded-xl shadow-lg flex gap-4 items-center cursor-pointer"
  >
    <BuildingOfficeIcon className="w-12 h-12" />
    <div>
      <p>Total Projects</p>
      <p className="text-4xl font-bold">{projectCount}</p>
    </div>
  </div>
)}

{role !== "branchUser" && (
  <div
    onClick={handleAllProgramsClick}
    className="p-6 bg-[#0F766E] text-white rounded-xl shadow-lg flex gap-4 items-center cursor-pointer"
  >
    <ClipboardDocumentListIcon className="w-12 h-12" />
    <div>
      <p>Total Programs</p>
      <p className="text-4xl font-bold">{programCount}</p>
    </div>
  </div>
)}
</div>
    )}
  </>
)}
{role !== "branchUser" && view === "dashboard" && !loading && (
  <div className="mt-6 flex flex-col md:flex-row gap-6">
    {/* Location Wise Enrollments */}
    <div className="w-full md:w-[60%]">
      <Card>
        <CardContent>
          <Typography variant="h6">
            Location Wise Enrollments
          </Typography>

          {loadingCharts || locationChart.length === 0 ? (
            <ChartSkeleton height={360} />
          ) : (
            <BarChart
              height={360}
              margin={{ top: 20, bottom: 90, left: 40, right: 20 }}
              xAxis={[
                {
                  scaleType: "band",
                  data: locationChart.map((d) => d.label),
                  tickLabelStyle: {
                    angle: 0,
                    textAnchor: "middle",
                    fontSize: 12,
                    fontWeight: 500,
                  },
                },
              ]}
              series={[
                {
                  data: locationChart.map((d) => d.value),
                  label: "Candidates",
                },
              ]}
            />
          )}
        </CardContent>
      </Card>
    </div>

    {/* Project Wise Enrollments */}
    <div className="w-full md:w-[40%]">
      <Card>
        <CardContent>
          <Typography variant="h6">
            Project Wise Enrollments
          </Typography>

          {loadingCharts || projectChart.length === 0 ? (
            <ChartSkeleton height={320} />
          ) : (
            <PieChart
              height={320}
              series={[
                {
                  data: projectChart.map((d, i) => ({
                    id: i,
                    value: d.value,
                    label: d.label,
                  })),
                  innerRadius: 40,
                  paddingAngle: 3,
                },
              ]}
            />
          )}
        </CardContent>
      </Card>
    </div>
  </div>
)}



      {/* ================= PROJECTS ================= */}
{view === "projects" && (
  <>
    {loadingProjects ? (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <ProjectSkeleton key={i} />
        ))}
      </div>
    ) : projects.length === 0 ? (
      <p className="text-center text-gray-500 mt-10">
        No projects found
      </p>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {projects.map((project) => {
          const normalizedProject =
            PROJECT_NORMALIZE_MAP[project] || project;

          return (
            <div
              key={project}
              onClick={() => handleOpenProject(project)}
              style={{
                backgroundColor:
                  PROJECT_COLORS[normalizedProject] ||
                  DEFAULT_PROJECT_COLOR,
              }}
              className="p-6 text-white rounded-xl shadow-lg cursor-pointer
                         flex justify-between items-center hover:scale-[1.03]"
            >
              <span className="font-semibold">{project}</span>
              <span className="bg-white text-black px-3 py-1 rounded-full text-sm font-bold">
                {projectCounts[normalizedProject] || 0}
              </span>
            </div>
          );
        })}
      </div>
    )}
  </>
)}



{view === "programs" && (
  <>
    {loadingLocations ? (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <ProgramSkeleton key={i} />
        ))}
      </div>
    ) : programs.length === 0 ? (
      <p className="text-center text-gray-500 mt-10">
        No programs available for this project
      </p>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {programs.map((prog) => (
          <div
            key={prog}
            onClick={() => handleProgramClick(prog)}
            className="p-5 bg-[#0F766E] text-white rounded-lg shadow
                       cursor-pointer flex justify-between items-center"
          >
            <span>{prog}</span>
            <span className="bg-white text-black px-3 py-1 rounded-full text-sm font-bold">
              {programCounts[prog] || 0}
            </span>
          </div>
        ))}
      </div>
    )}
  </>
)}



{view === "locations" && selectedProgram && (
  <>
    {/* HEADER + FILTER */}
    <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
      <h2 className="text-xl font-bold">
        {selectedProgram.name} – Centers
      </h2>

      {/* LOCATION DROPDOWN */}
      <select
        value={locationFilter}
        onChange={(e) => setLocationFilter(e.target.value)}
        className="border px-3 py-2 rounded-lg text-sm bg-white"
      >
        <option value="">All Locations</option>
        {locationOptions.map((loc) => (
          <option key={loc} value={loc}>
            {loc}
          </option>
        ))}
      </select>
    </div>

    {loadingLocations ? (
      <LocationSkeleton />
    ) : (
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg shadow">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Center</th>
              <th className="p-3 text-center">Enrolled</th>
              <th className="p-3 text-center">Approved</th>
            </tr>
          </thead>

          <tbody>
            {selectedProgram.branches
              .filter((branch) =>
                locationFilter
                  ? branch.location === locationFilter
                  : true
              )
              .map((branch) => {
                const stats = branchCounts[branch._id] || {
                  total: 0,
                  approved: 0,
                };

                return (
                  <tr
                    key={branch._id}
                    onClick={() => handleCenterClick(branch)}
                    className="border-t cursor-pointer hover:bg-gray-50"
                  >
                    <td className="p-3 font-semibold">
                      {branch.name}
                      <div className="text-xs text-gray-500">
                        {branch.location}
                      </div>
                    </td>

                    <td className="p-3 text-center font-bold text-blue-600">
                      {stats.total}
                    </td>

                    <td className="p-3 text-center font-bold text-green-600">
                      {stats.approved}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    )}
  </>
)}




 
{view === "centerCandidates" && selectedBranch && (
  <>
    {/* TOP BAR */}
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <h2 className="text-xl font-bold flex-1">
        {selectedBranch.name} – Candidates
      </h2>

      {/* 📅 SINGLE DATE PICKER */}
      <input
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="border px-3 py-1 rounded"
      />

      {/* ✅ TODAY COUNT */}
      <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold">
        Today: {todayCount}
      </span>
    </div>

    {/* TABLE */}
    {centerCandidates.length === 0 ? (
      <p className="text-gray-500">No candidates found</p>
    ) : (
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg shadow">
        <thead className="bg-gray-100">
  <tr>
    <th className="p-3 text-left">Name</th>
    <th className="p-3 text-left">Contact</th>
    <th className="p-3 text-left">Location</th>
    <th className="p-3 text-left">Created Date</th>
    <th className="p-3 text-center">Status</th>
    <th className="p-3 text-center">Actions</th>
  </tr>
</thead>


<tbody>
  {centerCandidates.map((c) => (
    <tr key={c._id} className="border-t hover:bg-gray-50">

      {/* NAME */}
      <td className="p-3 font-semibold">{c.name}</td>

      {/* CONTACT */}
      <td className="p-3">{c.contactNumber}</td>

      {/* LOCATION */}
      <td className="p-3">{c.location}</td>

      {/* CREATED DATE */}
      <td className="p-3">
        {new Date(c.createdAt).toLocaleDateString("en-IN")}
      </td>

      {/* STATUS */}
      <td className="p-3 text-center">
        <span
          className={`px-3 py-1 rounded-full text-xs font-bold
            ${
              c.approvalstatus === "Approved"
                ? "bg-green-100 text-green-700"
                : c.approvalstatus === "Rejected"
                ? "bg-red-100 text-red-700"
                : "bg-yellow-100 text-yellow-700"
            }
          `}
        >
          {c.approvalstatus || "Pending"}
        </span>
      </td>
      {/* ACTIONS */}
      <td className="p-3 text-center">
        <div className="flex justify-center gap-2">
{/* ✅ APPROVE (ADMIN + PENDING ONLY) */}
          {role === "admin" && c.approvalstatus === "Pending" && (
            <button
              onClick={() => {
                setApprovalCandidate(c);
                setApprovalStatus("");
                setApprovalReason("");
                setApprovalDialog(true);
              }}
              className="p-2 rounded-lg bg-green-100 hover:bg-green-200"
              title="Approve / Reject"
            >
              <CheckCircleIcon className="w-5 h-5 text-green-600" />
            </button>
          )}
        </div>
      </td>

    </tr>
  ))}
</tbody>



        </table>

      </div>
      
    )}
                      <Dialog open={approvalDialog} onClose={() => setApprovalDialog(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Approve / Reject Candidate</DialogTitle>

  <DialogContent>
    <Typography fontWeight="bold">
      {approvalCandidate?.name}
    </Typography>

    <Box mt={3}>
      <select
        value={approvalStatus}
        onChange={(e) => setApprovalStatus(e.target.value)}
        className="w-full border rounded px-3 py-2"
      >
        <option value="">Select Action</option>
        <option value="Approved">Approve</option>
        <option value="Rejected">Reject</option>
      </select>
    </Box>

    {approvalStatus === "Rejected" && (
      <Box mt={2}>
        <textarea
          value={approvalReason}
          onChange={(e) => setApprovalReason(e.target.value)}
          placeholder="Enter rejection reason"
          className="w-full border rounded px-3 py-2"
          rows={3}
        />
      </Box>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setApprovalDialog(false)}>Cancel</Button>

    <Button
      variant="contained"
      disabled={!approvalStatus || (approvalStatus === "Rejected" && !approvalReason)}
      onClick={async () => {
        await approveCandidate(approvalCandidate._id, {
          approvalstatus: approvalStatus,
          approvalReason,
        });

        setApprovalDialog(false);
        handleCenterClick(selectedBranch); // 🔄 refresh list
      }}
    >
      Submit
    </Button>
  </DialogActions>
</Dialog>
  </>
)}

      {/* ================= ALL PROGRAMS ================= */}
{view === "allPrograms" && (
  <>
    {Object.keys(allProgramsByProject).length === 0 ? (
      <p className="text-center text-gray-500 mt-10">
        No programs found
      </p>
    ) : (
      <div className="space-y-8">
        {Object.keys(allProgramsByProject).map((project) => (
          <div key={project} className="rounded-xl shadow-lg overflow-hidden">
            <div
              style={{
                backgroundColor:
                  PROJECT_COLORS[project] || DEFAULT_PROJECT_COLOR,
              }}
              className="px-6 py-4 text-white font-semibold"
            >
              {project}
            </div>

            <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4 bg-gray-50">
              {allProgramsByProject[project].map((prog) => (
                <div
                  key={prog}
                  className="p-4 bg-white rounded-lg shadow"
                >
                  {prog}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )}
  </>
)}

    </div>
  );
};

export default Dashboard;
